/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import moment from 'moment';

import {
    Col,
    Row,
    DatePicker,
    Checkbox,
    Slider,
} from 'antd';
import dayjs from 'dayjs';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';


const Filter = (props) => {
    const [startingFee, setStartingFee] = useState(0);
    const [endFee, setEndFee] = useState(5000);
    const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().add(7, 'days').format('YYYY-MM-DD'));
    const [consultationType, setConsultationType] = useState([1, 2, 3, 4]);
    const [radio, setRadio] = useState(['Male', 'Female']);    

    const dateFormat = 'YYYY-MM-DD';


    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;   


    const onSliderChange = (value) => {
        setStartingFee(value[0]);
        setEndFee(value[1]);
    };

    const onStartDateChange = (date, dateString) => {

        setStartDate(moment(dateString));
        props.payload.setStartDate(moment(dateString));

        // setEndDate(date === null ? null : moment(dateString).add(7, 'days'));
        setEndDate(date === null ? null : moment(dateString).add(7, 'days').format('YYYY-MM-DD'));
        props.payload.setEndDate(date === null ? null : moment(dateString).add(7, 'days').format('YYYY-MM-DD'));

        props.payload.setCurrentPage(1);
    };

    const disabledDate = current => current <= moment().subtract(1, 'days').endOf('day');

    const onEndDateChange = (date, dateString) => {

        setEndDate(dateString);
        props.payload.setEndDate(dateString);

        props.payload.setCurrentPage(1);

    };

    const disabledEndDate = endDate => {
        const startDateValue = startDate;
        if (!endDate || !startDateValue) {
            return false;
        }
        return endDate.valueOf() <= startDateValue.valueOf();
    };

    const onConsultChange = (value) => {
        setConsultationType(value);
        props.payload.setConsultationType(value);
        props.payload.setCurrentPage(1);
    };

    const onRadioChange = value => {
        
        if (value.length === 1) {
            setRadio(value);
            props.payload.setRadio(value);
        } else if (value.length === 2) {
            setRadio('');
            props.payload.setRadio('');    
        } else if (value.length === 0) {
            setRadio('');
            props.payload.setRadio('');
        }

        props.payload.setCurrentPage(1);

    };

    const page = props.page;

    switch (page) {
    case '1':
        return (
            <Row>
                {/* <Card> */}
                <p>{langdata.StartDate ? langdata.StartDate : 'Start Date'}</p>
                <Col>
                    <DatePicker
                        value={dayjs(moment(startDate).format('YYYY-MM-DD'), dateFormat)}
                        format={dateFormat}
                        onChange={onStartDateChange}
                        disabledDate={disabledDate}
                        allowClear={false}
                        style={{ width: '100%' }}
                    />
                </Col>
                <p>{langdata.EndDate ? langdata.EndDate : 'End Date'}</p>
                <Col>
                    <DatePicker
                        value={dayjs(moment(endDate).format('YYYY-MM-DD'), dateFormat)}
                        format={dateFormat}
                        onChange={onEndDateChange}
                        disabledDate={disabledEndDate}
                        allowClear={false}
                        style={{ width: '100%' }}
                    />
                </Col>
                {/* </Card> */}
            </Row>
        );

    case '2':
        return (
            <>
                {/* <Card> */}
                <p>{langdata.consultType ? langdata.consultType : 'Consultation Type'}</p>
                <Checkbox.Group
                    style={{ width: '100%', height: 'auto' }}
                    defaultValue={consultationType}
                    onChange={onConsultChange}
                >
                    <Col span={24} key={1}
                        style={{
                            marginTop: '10px'
                        }}>
                        <Checkbox value={1}> {langdata.hospitalVisit ? langdata.hospitalVisit : 'Hospital Visit'} </Checkbox>
                    </Col>
                    <Col span={24} key={3} style={{
                        marginTop: '10px'
                    }}>
                        <Checkbox value={3}> {langdata.consultOnlines ? langdata.consultOnlines : 'Consult Online'} </Checkbox>
                    </Col>
                    <Col span={24} key={2} style={{
                        marginTop: '10px'
                    }}>
                        <Checkbox value={2}> {langdata.ondemandHospital ? langdata.ondemandHospital : 'Ondemand Hospital'} </Checkbox>
                    </Col>
                    <Col span={24} key={4} style={{
                        marginTop: '10px'
                    }}>
                        <Checkbox value={4}> {langdata.ondemandVideo ? langdata.ondemandVideo : 'Ondemand Video'} </Checkbox>
                    </Col>
                </Checkbox.Group>

                {/* </Card> */}
            </>
        );

    case '3':
        return (
        // <Card>
            <>
                <p>{langdata.fee ? langdata.fee : 'Fee'}</p>
                <Slider
                    min={0}
                    max={5000}
                    range
                    step={10}
                    defaultValue={[0, 5000]}
                    onChange={onSliderChange}
                />
                <p style={{ textAlign: 'center' }}>
                        Rs {startingFee} - Rs {endFee}
                </p>
            </>
        // </Card>
        );

    case '4':
        return (
        // <Card>
            <>
                <p>{langdata.gender ? langdata.gender : 'Gender'}</p>
                <Checkbox.Group style={{ width: '100%' }} onChange={onRadioChange} defaultValue={radio}>
                    <Row>
                        <Col span={24} key={1} style={{
                            marginTop: '10px'
                        }}>
                            <Checkbox value={'Male'}>
                                {langdata.male ? langdata.male : 'Male'}
                            </Checkbox>
                        </Col>
                        <Col span={24} key={3} style={{
                            marginTop: '10px'
                        }}>
                            <Checkbox value={'Female'}>
                                {langdata.female ? langdata.female : 'Female'}</Checkbox>
                        </Col>
                    </Row>
                </Checkbox.Group>
            </>
        // </Card>
        );

    default:
        return (
        // <Card>
            <div style={{ textAlign: 'center' }}>
                {langdata.Nofilter ? langdata.Nofilter : 'No filter'}
            </div>
        );
    }
};

export default Filter;
